(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/react-help-utils/assets/javascripts/create-store.js') >= 0) return;  svs.modules.push('/components/utils/react-help-utils/assets/javascripts/create-store.js');
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


(function (svs) {
  var _RTK = RTK,
    createStore = _RTK.createStore,
    combineReducers = _RTK.combineReducers,
    applyMiddleware = _RTK.applyMiddleware,
    compose = _RTK.compose;
  var composeEnhancers = compose;

  if (svs.core.config.data.svsconfig.env !== 'production') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }
  svs.utils.reactHelpUtils.createStore = function (reducers) {
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var middleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var reducer;
    var enhancer = applyMiddleware.apply(void 0, [ReduxThunk.default].concat(_toConsumableArray(middleware)));
    if (typeof reducers === 'function') {
      reducer = reducers;
    } else {
      reducer = combineReducers(reducers);
    }
    var store = createStore(reducer, initialState, composeEnhancers(enhancer));

    svs.utils.reactHelpUtils.store = store;
    return store;
  };
})(svs);

 })(window);